import { render, staticRenderFns } from "./DepublishPage.vue?vue&type=template&id=37279cbe&scoped=true"
import script from "./DepublishPage.vue?vue&type=script&lang=js"
export * from "./DepublishPage.vue?vue&type=script&lang=js"
import style0 from "./DepublishPage.vue?vue&type=style&index=0&id=37279cbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37279cbe",
  null
  
)

export default component.exports